import { ROUTES } from "@web-solutions/core/constants/routes";

export const get3DSRedirectURLs = () => {
  const url = window.location.origin;

  return {
    successUrl: `${url}${ROUTES.VERIFY_3DS_SUCCESS}`,
    failUrl: `${url}${ROUTES.VERIFY_3DS_FAIL}`
  }
}